import * as React from 'react'

import Stack from '@mui/material/Stack'

import { I18n, useTranslation } from 'components/hooks/use-translation'
import Icon from 'components/atomic/atoms/icon'
import Text from 'components/atomic/atoms/text'
import { Path } from 'types/types'

const FullDescription = (props: Path) => {
    const { t }: I18n = useTranslation()

    return (
        <div>
            <Stack direction="row" spacing="0.5rem" alignItems="center">
                <Icon fontSize="small" color="primary" name="helpOutline" />
                <Text variant="overline" color="primary">
                    {t('path:descriptionSection.title')}
                </Text>
            </Stack>
            <Text variant="h6">{props.description}</Text>
        </div>
    )
}

export default FullDescription
